import React from "react";



const PackageNotFoundToken =()=>{


    return(
        <div className="w-96 h-52 px-8 py-8 bg-white rounded-tl-2xl rounded-bl-2xl flex-col justify-start items-center gap-8 inline-flex">
        <div className="w-14 h-14 relative">
          <div className="w-14 h-14 left-0 top-0 absolute bg-black rounded-full" />
          <div className="w-1.5 h-1.5 left-[24.75px] top-[39.88px] absolute bg-white rounded-full" />
        </div>
        <div className="flex-col justify-start items-center gap-3 flex">
          <div className="w-56 text-center text-black text-xl font-semibold font-['Inter']">Uyarı</div>
          <div className="text-center text-zinc-800 text-xs font-normal font-['Inter']">Paket bilgisi bulunamadı.</div>
        </div>
      </div>
    );
}
export default PackageNotFoundToken;